import type { ProductResponse } from "../productsApi";

export function productWithoutLocation(product: ProductResponse): ProductResponse {
  return {
    ...product,
    contact: {
      ...product.contact,
      googlePlaceId: undefined,
      googlePlaceGeometry: undefined,
    },
  };
}
